// WorkflowStepKey is the signal to the backend to replace this with data from a step in the workflow
// This shouldn't be needed outside of this file so it's not exported.
import { AutomationInterface } from '@vendasta/automata';
import { TranslateService } from '@ngx-translate/core';

const WorkflowStepKey = '.WorkflowStep';
const CurrentActivityDetailsKey = WorkflowStepKey + '.current_activity_details';

// buildStepReferenceString will build the string that will be replaced with real data from the workflow when it runs
// this can be used in Rules or just the Data portion of a workflow step
export function buildStepReferenceString(stepId: string, parameter: string): string {
  return `{${WorkflowStepKey}.${stepId}.${parameter}}`;
}

// separates groups to get the last dot separated group
// for example, {.WorkflowStep.12390kladdf-klajdsf9323.partner_id} will match partner_id
const keyDotDelimitedRegex = '[^.]+(?=.[^.]*$)[^.]+(?=.[^.]*$)';

export function extractWorkflowStepParameterKeyFromReplacementTag(replacementTag: string): string {
  const matches = (replacementTag || '').match(keyDotDelimitedRegex);
  if (matches?.length > 0) {
    return matches[0];
  }
  return '';
}

// separates groups to get the middle dot separated group
// for example, {.WorkflowStep.12390kladdf-klajdsf9323.partner_id} will match 12390kladdf-klajdsf9323
const dotDelimitedRegex = '[^.]+(?=.[^.]*$)';

export function extractWorkflowStepIdFromReplacementTag(replacementTag: string): string {
  const matches = (replacementTag || '').match(dotDelimitedRegex);
  if (matches?.length > 0) {
    return matches[0];
  }
  return '';
}

export function isReferencingAPreviousStep(possibleReplacementTag: string): boolean {
  return possibleReplacementTag?.indexOf(`{${WorkflowStepKey}.`) >= 0;
}

export function isReferencingCurrentActivityDetails(possibleReplacementTag: string): boolean {
  return possibleReplacementTag?.indexOf(`{${CurrentActivityDetailsKey}.`) >= 0;
}

// If the string passed in is a reference to a previous step it will return a string that you can display to users to show this. If it's not a step reference
// it will just return the param
export function convertToStepReferenceString(
  param: string,
  a: AutomationInterface,
  translateService: TranslateService,
): string {
  if (isReferencingAPreviousStep(param)) {
    let name = '';
    if (isReferencingCurrentActivityDetails(param)) {
      name = translateService.instant('HTML_EDITOR.DYNAMIC_CONTENT.AUTOMATION_DETAILS');
    } else {
      const workflowStepId = extractWorkflowStepIdFromReplacementTag(param);
      const step = (a.workflow || []).concat(a.triggerStep).find((s) => s?.id === workflowStepId);
      name = step?.name || step?.id;
    }
    return name + '[' + extractWorkflowStepParameterKeyFromReplacementTag(param) + ']';
  } else {
    return param;
  }
}
